import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'
import { removeToken } from '@/lib/auth.ts'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

function AuthExpiryListener() {
  const navigate = useNavigate()

  useEffect(() => {
    const handler = () => {
      removeToken()
      navigate('/login', { replace: true })
    }

    window.addEventListener('auth:expired', handler)
    return () => window.removeEventListener('auth:expired', handler)
  }, [navigate])

  return null
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthExpiryListener />
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
